/* eslint-disable */
import React, { useState } from 'react';
import { AccordionSection, SwatchLegendItem } from 'mapcontrols/components/subComponents';
import { PLACE_LIST, PROXIMITY_SECTION_OBJ, RANGE_LIST, PROXIMITY_RANGE_LIST_OBJ } from 'mapcontrols/constants';
import { BaseSelect } from 'ui-kit';
import * as Styled from './styles';
import { ProximityLayerItem } from './ProximityLayerItem';

const ProximitySection = ({
  collapsedArrowIcon = '',
  expandedArrowIcon = '',
  activeSections = {},
  onSectionToggle = () => {},
  densitySelection = null,
  proximitySelection = null,
  onProximityLayerToggle = () => {},
  onProximityRangeChange = () => {},
  onProximityPlaceChange = () => {},
}) => {
  const currentProximitySelection = proximitySelection || {
    activeLayer: 'no_proximity',
    layerConfigs: {
      near_school: {
        range: '1000',
        place: 'near_school',
      },
      near_retailer: {
        range: '1000',
      },
    },
  };

  const getLayerConfigType = (layerId) => {
    if (layerId === 'retailersnearretailers_az') {
      return 'near_retailer';
    }
    if (['retailersnearschools_az', 'retailersnearparks_az'].includes(layerId)) {
      return 'near_school';
    }
    return null;
  };

  const getCurrentRangeOption = (configType) => {
    const config = currentProximitySelection.layerConfigs[configType];
    if (!config) return RANGE_LIST[1];
    return RANGE_LIST.find((item) => item.value === config.range) || RANGE_LIST[1];
  };

  const getCurrentPlaceOption = () => {
    const config = currentProximitySelection.layerConfigs.near_school;
    if (!config) return PLACE_LIST[1];
    return PLACE_LIST.find((item) => item.value === config.place) || PLACE_LIST[1];
  };

  const nearPublicRange = getCurrentRangeOption('near_school');
  const nearRetailesRange = getCurrentRangeOption('near_retailer');
  const nearPlace = getCurrentPlaceOption();

  const handleSelectNearSchoolRange = (selectedValue) => {
    onProximityRangeChange(selectedValue.value);
  };

  const handleSelectNearPlace = (selectedValue) => {
    onProximityPlaceChange(selectedValue.value);
  };

  const handleSelectNearReatilesRange = (selectedValue) => {
    onProximityRangeChange(selectedValue.value);
  };

  const handleProximityLayerToggle = (layerId, isChecked) => {
    const configType = getLayerConfigType(layerId);

    if (configType && currentProximitySelection.layerConfigs[configType]) {
      const config = currentProximitySelection.layerConfigs[configType];
      onProximityLayerToggle(layerId, isChecked, config.range, config.place);
    } else {
      onProximityLayerToggle(layerId, isChecked);
    }
  };

  const isLayerActive = (layerId) => {
    if (layerId === 'retailerpoints') {
      const currentDensitySelection = densitySelection || { retailerpoints: false };
      return currentDensitySelection.retailerpoints;
    }

    if (layerId === 'no_proximity') {
      return currentProximitySelection.activeLayer === 'no_proximity';
    }

    if (layerId === 'retailersnearschools_az') {
      return currentProximitySelection.activeLayer === 'retailersnearschools_az';
    }

    if (layerId === 'retailersnearretailers_az') {
      return currentProximitySelection.activeLayer === 'retailersnearretailers_az';
    }

    return false;
  };

  const subPanels = {
    retailersNearSchoolsSubpanel: {
      title: (
        <>
          <Styled.TitleSelectionWrapper>
            <BaseSelect
              name="retailer-proximity-range"
              options={RANGE_LIST}
              value={nearPublicRange}
              onChange={(selectedValue) => handleSelectNearSchoolRange(selectedValue)}
              inputId="retailer-proximity-range"
              className="proximity-range"
            />
            <span> of : </span>
            <BaseSelect
              name="proximity-place"
              options={PLACE_LIST}
              value={nearPlace}
              onChange={(selectedValue) => handleSelectNearPlace(selectedValue)}
              inputId="proximity-place"
              className="proximity-place"
            />
          </Styled.TitleSelectionWrapper>
        </>
      ),
      legends: (
        <>
          <Styled.SwatchLegendSection>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="#913fdf" borderColor="#000000" />
              <span>Retailer is near selected location</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="#f28e36" borderColor="#000000" />
              <span>Retailer is not near selected location</span>
            </Styled.SwatchLegendWrapper>
            <em style={{ fontSize: '85%' }}>Note: This view is only available at close-up levels.</em>
          </Styled.SwatchLegendSection>
        </>
      ),
    },
    retailersNearRetailersSubpanel: {
      title: (
        <>
          <Styled.TitleSelectionWrapper>
            <BaseSelect
              name="retailer-proximity-range"
              options={RANGE_LIST}
              value={nearRetailesRange}
              onChange={(selectedValue) => handleSelectNearReatilesRange(selectedValue)}
              inputId="retailer-proximity-range"
              className="proximity-range"
            />
            <span> of another retailer </span>
          </Styled.TitleSelectionWrapper>
        </>
      ),
      legends: (
        <>
          <Styled.SwatchLegendSection>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="#913fdf" borderColor="#000000" />
              <span>Retailer is near another retailer</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="#f28e36" borderColor="#000000" />
              <span> Retailer is not near another retailer</span>
            </Styled.SwatchLegendWrapper>
            <Styled.SwatchLegendWrapper>
              <SwatchLegendItem backgroundColor="#B8B8B8" borderColor="#000000" />
              <span> Out of business / Does not sell tobacco</span>
            </Styled.SwatchLegendWrapper>
            <em style={{ fontSize: '85%' }}>Note: This view is only available at close-up levels.</em>
          </Styled.SwatchLegendSection>
        </>
      ),
    },
  };

  return (
    <AccordionSection
      title="Proximity"
      id="proximity"
      activeSections={activeSections}
      onSectionToggle={onSectionToggle}
      collapsedArrowIcon={collapsedArrowIcon}
      expandedArrowIcon={expandedArrowIcon}
    >
      {PROXIMITY_SECTION_OBJ.map((item) => (
        <ProximityLayerItem
          key={item.id}
          layerId={item.id}
          label={item.label}
          stackingOrder={item.stackingOrder}
          swatchStyle={item?.swatchStyle}
          isActive={isLayerActive(item.id)}
          onToggle={handleProximityLayerToggle}
          subpanel={subPanels?.[item.subpanel]?.legends}
          inputType={item.inputType}
          type={item.type}
        >
          {subPanels?.[item.subpanel]?.title}
        </ProximityLayerItem>
      ))}
    </AccordionSection>
  );
};

export default ProximitySection;
